<div class="ui-wallet">
  <img class="ui-wallet-img" [src]="walletImgSrc()" [alt]="user().fullName" />
  <iw-avatar class="ui-wallet-avatar" [firstName]="user().holderFirstName" />
</div>

<p class="ui-details">
  <span class="ui-details-name">{{ user().fullName }}</span>
  <span class="ui-details-id">
    {{
      (selected()
        ? "accountWithAmount.userItem.selected.id"
        : "accountWithAmount.userItem.id"
      ) | translate: { id: user().accountId }
    }}
  </span>
</p>
